import React from 'react';
import { useSelector } from 'react-redux';
import { Form } from 'antd';
import cn from 'classnames';
import { isHtmlSelector } from '../../store/selectors';
import UploadLocalFiles from '../UploadLocalFiles/UploadLocalFiles';
import LocalFileList from '../LocalFileList/LocalFileList';
import OpenEditor from '../OpenEditor/OpenEditor';
import { useSubmit } from './SubmitProvider';
import MessageBlock from './MessageBlock';
import Counter from './Counter';
import { SubmitProvider } from './SubmitProvider';
import SubmitBtn from './SubmitBtn';
import styles from './PostMessageForm.module.scss';

const PostMessageForm = ({ className, onAddMsgSuccess }) => {
  return (
    <Container
      className={className}
      onAddMsgSuccess={onAddMsgSuccess}
      upload={<UploadBlock />}
      submit={<SubmitBtn />}
      fileList={<LocalFileList />}
    />
  );
};

export default PostMessageForm;

function Container({ onAddMsgSuccess, className, upload, submit, fileList }) {
  const isHtml = useSelector(isHtmlSelector);

  return (
    <Form className={cn(styles.root, className, { [styles.isHtml]: isHtml })}>
      <SubmitProvider onAddMsgSuccess={onAddMsgSuccess}>
        <div className={cn(styles.container, { [styles.isHtml]: isHtml })}>
          <MessageBlock isHtml={isHtml} />
          <div className={cn(styles.actions, { [styles.isHtml]: isHtml })}>
            <div className={styles.col}>
              {upload}
              {!isHtml && (
                <OpenEditor className={cn(styles.btn, styles.uploadBtn)} />
              )}
            </div>

            <div className={styles.col}>
              <Counter isHtml={isHtml} />
              {submit}
            </div>
          </div>

          {fileList}
        </div>
      </SubmitProvider>
    </Form>
  );
}

function UploadBlock() {
  const { loading } = useSubmit();

  return (
    <UploadLocalFiles
      disabled={loading}
      btnClassName={cn(styles.btn, styles.uploadBtn)}
    />
  );
}
